import PageComponent from '../base/PageComponent';
import '../../../node_modules/waypoints/lib/jquery.waypoints';

export default class Navigation extends PageComponent {

    init() {
        this.mobileNav();
        this.replaceMenuText();
        this.stickyNav();
    }

    onWindowResize() {
        this.stickyNav();
    }

    mobileNav() {
        this.addEvent('.mobile-menu-button', 'click', e => this.onMenuClick(e));
    }

    onMenuClick(e) {
        let nav = $('.site__nav-items');

        if (nav.is(':visible')) {
            nav.slideUp();
        }
        else {
            nav.slideDown();
        }
    }

    replaceMenuText() {
        let mobileMenu = $('.mobile-menu-button-text'),
            currentPage = $('.site__nav-items li.current a').html();

        if ($('.site__nav-items li').hasClass('current')) {
            mobileMenu.replaceWith(currentPage);
        }
    }

    stickyNav() {
        let navigation = $('.site__nav'),
            siteContent = $('.site__content'),
            topOffset = navigation.offset().top;

        // $(window).scroll(function () {
        //     if ($(this).scrollTop() > topOffset) {
        //         navigation.addClass('sticky');
        //         siteContent.addClass('spacing-top');
        //         console.log('sticky');
        //     } else {
        //         navigation.removeClass('sticky');
        //         siteContent.removeClass('spacing-top');
        //         console.log('no-sticky');
        //     }
        // });

        $('.site__nav').waypoint(function(direction){
            if(direction === "down"){
                $('.site__nav').addClass('sticky');
            }
            else {
                $('.site__nav').removeClass('sticky');
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/js/components/Navigation.js